import { render, staticRenderFns } from "./userSelection.vue?vue&type=template&id=000bb266&scoped=true"
import script from "./userSelection.vue?vue&type=script&lang=js"
export * from "./userSelection.vue?vue&type=script&lang=js"
import style0 from "./userSelection.vue?vue&type=style&index=0&id=000bb266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bb266",
  null
  
)

export default component.exports